import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=ef1e358a"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
import style0 from "./Slider.vue?vue&type=style&index=0&id=ef1e358a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef1e358a')) {
      api.createRecord('ef1e358a', component.options)
    } else {
      api.reload('ef1e358a', component.options)
    }
    module.hot.accept("./Slider.vue?vue&type=template&id=ef1e358a", function () {
      api.rerender('ef1e358a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/preSubjectHistory/Slider.vue"
export default component.exports